"use client"

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "../hooks/useTranslation";
import { useGamingHub } from "../providers/GamingHubProvider";
import { Spinner } from "./loading-spinner";

export function LoginButton() {
  const { t } = useTranslation();
  const { login, isReady } = useGamingHub();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    // Not reset: showLogin() navigates to the identity provider.
    setIsLoading(true);
    login();
  };

  return (
    <Button type="button" onClick={handleClick} disabled={isLoading || !isReady}>
      {isLoading ? (
        <span className="flex items-center gap-2">
          <Spinner size={16} className="text-white" />
          {t('menu.login')}...
        </span>
      ) : (
        t('menu.login')
      )}
    </Button>
  )
}
